import {Directive, inject, input, output} from '@angular/core';
import {ConfirmationDialogComponent} from './confirmation-dialog.component';
import {MatDialog} from '@angular/material/dialog';

@Directive({
  selector: '[xuiConfirmationDialog]',
  host: {
    '(click)': 'click()'
  }
})
export class ConfirmationDialogDirective {
  private dialog = inject(MatDialog);

  readonly confirmTitle = input('Confirm');
  readonly confirmMessage = input('Are you sure?');
  readonly confirm = output<void>();

  click(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { title: this.confirmTitle(), message: this.confirmMessage() }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) { this.confirm.emit(); }
    });
  }
}
